import React from "react";

export function ErrorHandler() {
    return (
        <div className="error-handler">Ничего не найдено</div>
    );
}